import React, { useEffect, useState } from "react";
import MessageContent from "./MessageContent";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { communicationChatList } from "../../../services/communicationService";

const StartChatModal = ({ isOpen, onClose, user }) => {
  const [activeChat, setActiveChat] = useState(null);
  const queryClient = useQueryClient();

  const { data: chatData, isLoading: isChatLoading } = useQuery({
    queryKey: ["start-chat", user?._id],
    enabled: !!isOpen && !!user?._id,
    queryFn: async () => {
      const res = await communicationChatList({
        customerId: user._id,
        type: "chat",
        inboxType: "personal",
        limit: 5,
        sortQuery: "-createdAt",
      });

      return res?.docs?.data?.[0] || null;
    },
    staleTime: 0,
    cacheTime: 0,
  });

useEffect(() => {
  if (chatData?._id) {
    setActiveChat(chatData);
    return;
  }
  if (isChatLoading) return;
  if (user?._id) {
    setActiveChat({
      _id: `temp-${user._id}`,
      memberData: [user],
      communicationData: {
        recipientType: "user",
        inboxType: "personal",
      },
    });
  }
}, [chatData, user, isChatLoading]);

  useEffect(() => {
    if (isOpen && activeChat?._id) {
      queryClient.invalidateQueries({
        queryKey: ["chat-messages", activeChat._id],
      });
    }
  }, [isOpen, activeChat?._id, queryClient]);

  if (!isOpen) return null;

  return (
    <div className="fixed z-[100] bg-white border border-zinc-300 overflow-hidden w-full h-full inset-0 rounded-none sm:w-[95%] sm:h-[95vh] sm:bottom-2 sm:right-2 sm:left-2 sm:top-auto sm:rounded-2xl md:w-[400px] xl:w-[500px] md:h-[500px] xl:h-[600px] md:left-auto md:top-auto md:bottom-0 md: right-10 lg:right-40
        "
      >  
        <div className="w-full h-full overflow-hidden">
          {isChatLoading ? (
            <div className="h-full flex items-center justify-center text-gray-500">
              Loading conversation...
            </div>
          ) : (
            <MessageContent
              activeChat={activeChat}
              isModal={true}
              onClose={onClose}
            />
          )}
        </div>
      </div>
  );
};

export default StartChatModal;